function createAttribute(name) {
  return `data-base-ui-${name}`;
}
export {
  createAttribute
};
//# sourceMappingURL=createAttribute.js.map
